import { GenericTableColumn } from "@ui-components/Table/GenericTable"

export interface HealthCheckItem {
    id: string
    name: string
    description: string | null
    cpu: number | null
    ram: number | null
    storage: number | null
    processStatus: { active: number; total: number } | null
    mainStatus: string | null
    ports: string | null
    date: string | null
}

export const columns: GenericTableColumn<HealthCheckItem>[] = [
    {
        header: "Instance",
        accessor: "name",
        renderCell: (row) => row.name,
    },
    {
        header: "Status",
        accessor: "mainStatus",
        renderCell: (row) => row.mainStatus,
    },
    {
        header: "CPU (%)",
        accessor: "cpu",
        renderCell: (row) => row.cpu ?? "-",
    },
    {
        header: "RAM (%)",
        accessor: "ram",
        renderCell: (row) => row.ram ?? "-",
    },
    {
        header: "Storage (%)",
        accessor: "storage",
        renderCell: (row) => row.storage ?? "-",
    },
    {
        header: "Process Status",
        accessor: "processStatus",
        renderCell: (row) =>
            row.processStatus
                ? `${row.processStatus.active}/${row.processStatus.total}`
                : "-",
    },
    {
        header: "Port Status",
        accessor: "ports",
        renderCell: (row) => row.ports ?? "-",
    },
    {
        header: "Last Update",
        accessor: "date",
        renderCell: (row) =>
            row.date ? new Date(row.date).toLocaleString() : "-",
    },
]
